import React from 'react';

export function initials(username) {
  const s = (username || '?').trim();
  const parts = s.split(/[\s._-]+/).filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return s.slice(0, 2).toUpperCase();
}

// Avatar piatto: solo iniziali, nessuna cornice/sfondo. Il colore lo passa il contesto.
export default function Avatar({ username, size = 38, color = 'currentColor', weight = 800 }) {
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
      width: size, height: size, fontSize: Math.round(size * 0.46), fontWeight: weight,
      color, letterSpacing: '0.03em', lineHeight: 1, userSelect: 'none',
    }}>
      {initials(username)}
    </span>
  );
}
